export default __webpack_public_path__ + "static/media/landing-page.a049e32f.jpeg";